import React from "react";

// Classnames
import clsx from "clsx";

// Interface
interface ITitle {
  title?: string;
  subTitle?: string;
  className?: string;
}

export const Title: React.FC<ITitle> = (props) => {
  const { title, subTitle, className } = props;

  const cnWrapper = clsx(
    "impurities-for-drug__wrapper-title",
    className ? className : ""
  );

  return (
    <div className={cnWrapper}>
      <h4 className="impurities-for-drug__title relative mb10" dangerouslySetInnerHTML={{ __html: title || '' }} />
      <p className="impurities-for-drug__sub-title relative" dangerouslySetInnerHTML={{ __html: subTitle || '' }} />
    </div>
  );
};

export default Title;
